"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddableLensSubplaceWithoutRouter = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const LensLineageSubplace_1 = require("./LensLineageSubplace");
const EmbeddableLensSubplaceWithoutRouter = props => {
    return (react_1.default.createElement(data_catalog_shared_1.LineageBrowserDataCatalogProvider, Object.assign({}, props),
        react_1.default.createElement(LensLineageSubplace_1.LensLineageSubplaceRouter, { vizportalUrlId: props.vizportalUrlId })));
};
exports.EmbeddableLensSubplaceWithoutRouter = EmbeddableLensSubplaceWithoutRouter;
//# sourceMappingURL=EmbeddableLensSubplace.js.map